module.exports = __webpack_public_path__ + "static/img/img-sreen05.cbe763a.jpg";